import { useNavigate } from 'react-router-dom'
import { Hide, Show, Text, VStack } from '@chakra-ui/react'
import { useRegisterStep } from 'context'
import { themeColors } from 'theme'

import { WicarLogo, WicarLogoSmall } from 'components/SVGS'

import { StepOne } from './components/StepOne'
import { StepThree } from './components/StepThree'
import { StepTwo } from './components/StepTwo'

export const Register = () => {
  const history = useNavigate()
  const { container: { gradientColor: { gradientOne, gradientTwo, gradientThree } } } = themeColors
  const { registerStepState: { state: { step } } } = useRegisterStep()

  return (
    <VStack
      minH={'100vh'}
      minW={'100vw'}
      bgGradient={`linear(to-b, ${gradientOne}, ${gradientTwo}, ${gradientThree})`}>
      <VStack
        flex={1}
        mx="auto"
        w={'full'}
        maxW={{ base: '90%', md: '550px' }}
        h={'fit-content'}
        rounded='2xl'
        p={{ base: 2, md: 4 }}
        justifyContent='center'
        alignItems='center'
        spacing={{ base: 4, md: '70px' }}>
        <VStack cursor={'pointer'}>
          <Show below='md'>
            <WicarLogoSmall width={50} height={50} onClick={() => history('/')} />
          </Show>
          <Hide below='md'>
            <WicarLogo width={200} height={50} onClick={() => history('/')} />
          </Hide>
        </VStack>
        <VStack w={'full'} justifyContent={'center'} alignItems={'center'} spacing={'60px'}>
          <VStack>
            <Text variant={'LG_SB'} textAlign={'center'}>¡Hola!</Text>
            <Text textAlign={'center'}>
              Crea tu cuenta para poder acceder a todos los beneficios de WiCar
            </Text>
          </VStack>
          <VStack w={'full'}>
            {step === 0 && <StepOne />}
            {step === 1 && <StepTwo />}
            {step === 2 && <StepThree />}
          </VStack>
        </VStack>
      </VStack>
    </VStack>
  )
}
